<template>
  <div class="retry-loader">
    <loader v-if="!isErrorState" />
    <div v-else class="try-again">
      <span class="subtitle-bold" style="text-align: start">נראה שמשהו לא עבד 😰</span>
      <Button
        label=" ננסה שוב?"
        style="margin-top: 1rem;"
        @click="tryToLoad" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  isErrorState: {
    type: Boolean,
    required: true
  }
});
const emit = defineEmits(['retryFunction']);
const tryToLoad = () => emit('retryFunction');
</script>

<style lang="scss" scoped>
.retry-loader {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  .try-again {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
